import { Button } from '@breetometer/components';
import { useModalApi } from 'BreetHooks';

import check from '@/assets/images/gif/check.gif';

import ImageComponent from '../ImageComponent';
import type { IDialogFullScreenNotificationCtaType, IDialogFullScreenNotificationProps } from './helpers';

const DialogFullScreenNotification = () => {
	const { getModalProps, closeModalDirect } = useModalApi();

	const modal = getModalProps('fullScreenNotification') as unknown as IDialogFullScreenNotificationProps;

	const { header, subheader, cta, ctaType } = modal;

	const ctaTypeObj: Record<IDialogFullScreenNotificationCtaType, () => void> = {
		close: () => closeModalDirect('fullScreenNotification'),
		link: () => console.info('Link'),
	};

	const ctaHandler = ctaTypeObj[ctaType];
	return (
		<div className='fullScreenNotification'>
			<ImageComponent
				src={check}
				alt='success'
			/>
			<h1>{header}</h1>
			<p>{subheader}</p>
			<Button
				variant='tertiary'
				onClick={ctaHandler}
			>
				{cta}
			</Button>
		</div>
	);
};

export default DialogFullScreenNotification;
